/**
 * Created by AB74296 on 9/5/2017.
 */
import React, { Component, useState, useRef } from 'react';
import { observer } from 'mobx-react';
import { HashRouter, Route, Navigate, Routes } from 'react-router-dom';
import BlockUi from '@availity/block-ui';
import { IdleTimerProvider } from 'react-idle-timer';
import '@availity/block-ui/dist/index.css';
import { Header, IdleTimeOutModal } from '../components/index';
import ScrollToTop from '../utilities/scroll';
import commonStore from '../stores/commonStore';
import housingstore from '../../WA_TPA_FCS_Form/stores/housingstore';

import MemberInformation from '../../WA_TPA_FCS_Form/MemberInformation/MemberInformation';
import HealthNeeds from '../../WA_TPA_FCS_Form/ComplexNeeds/HealthNeeds';
import RiskFactors from '../../WA_TPA_FCS_Form/ComplexNeeds/RiskFactors';
import HousingAssessment from '../../WA_TPA_FCS_Form/HousingAssessment/HousingAssessment';
import Strengths from '../../WA_TPA_FCS_Form/HousingAssessment/Strengths';
import HousingPreference from '../../WA_TPA_FCS_Form/HousingAssessment/HousingPreference';
import PersonalInfoHousingHistory from '../../WA_TPA_FCS_Form/PersonalInfo&HousingHistory/PerInfoHousingHist';
import TransportationInformation from '../../WA_TPA_FCS_Form/HousingAssessment/TransportationInformation';
import AHAHRap from '../../WA_TPA_FCS_Form/AHAH/AHAHRap';
import SignatureComponent from '../../WA_TPA_FCS_Form/SignaturesDocumentation/Signature';
import ReviewSubmit from '../../WA_TPA_FCS_Form/ReviewSubmit/ReviewSubmit';
import Documentation from '../../WA_TPA_FCS_Form/SignaturesDocumentation/Documentation';
import ConfirmationScreen from '../../WA_TPA_FCS_Form/Confirmation/Confirmation';

const timeout = 18 * 10 * 10000
const timeoutAlert = 9 * 10 * 10000
let overLayTimer = null

const IdleTimeoutContainer = () => {
  const [showModal, setShowModal] = useState(false)
  const idleTimer = useRef(null)

  const onActive = (e) => {
    if (idleTimer?.current?.getRemainingTime() > 0)
      // eslint-disable-next-line no-console
      console.log('user is active, time remaining::')
  }

  const onIdle = (e) => {
    setShowModal(true)
    overLayTimer = setTimeout(() => {
      window.location.reload()
    }, timeoutAlert)
  }
  const handleClose = () => {
    setShowModal(false)
    window.location.reload()
    clearTimeout(overLayTimer)
  }
  const handleClose1 = () => {
    setShowModal(false)
  }
  return (
    <>
      <IdleTimerProvider
        ref={idleTimer}
        element={document}
        onActive={onActive}
        onIdle={onIdle}
        debounce={250}
        timeout={parseInt(timeout - timeoutAlert, 10)} />
      <IdleTimeOutModal
        showModal={showModal}
        handleClose={handleClose}
        handleClose1={handleClose1}
      // handleLogout={handleLogout}
      />
    </>
  )
}

@observer
class Layout extends Component {
  defaultRender = () => {
    housingstore.resetSupportiveHousingPage();
    housingstore.resetSupportiveHousingRoutesStatus();
    return <Navigate to="/" />;
  };

  renderRootPath = () => {
    return (
      <>
        <Route exact path="/healthneeds" element={<HealthNeeds />} />
        <Route exact path="/riskfactors" element={<RiskFactors />} />

        <Route exact path="/housingassessment" element={<HousingAssessment />} />
        <Route exact path="/strengths" element={<Strengths />} />
        <Route exact path="/housingpreference" element={<HousingPreference />} />
        <Route exact path="/personalhousinghist" element={<PersonalInfoHousingHistory />} />
        <Route exact path="/transportationinformation" element={<TransportationInformation />} />

        <Route exact path="/ahah-rap" element={<AHAHRap />} />

        <Route exact path="/signature" element={<SignatureComponent />} />

        <Route exact path="/documentation" element={<Documentation />} />

        <Route exact path="/reviewsubmit" element={<ReviewSubmit />} />
        
        <Route exact path="/confirmation" element={<ConfirmationScreen />} />

        <Route path="*" element={<this.defaultRender />} />
      </>
    );
  };

  render() {
    return (
      <div>
        <IdleTimeoutContainer />
        <Header commonStore={commonStore} />
        <HashRouter basename="/">
          <div className="container">
            <BlockUi tag="div" blocking={housingstore.blocking}>
              <ScrollToTop />
              <Routes>
                <Route exact path="/" element={<MemberInformation />} /> {/* Default route */}
                {this.renderRootPath()}
              </Routes>
            </BlockUi>
          </div>
        </HashRouter>
      </div>
    );
  }
}

export default Layout;